import { useEffect, useRef, useState } from "react";

// Animated number that counts up from its previous value to the new one
// using an easeOutCubic curve. Used for dashboard stat figures so the
// numbers feel alive on load / refresh instead of snapping into place.
//
//   <CountUp value={124} />
//   <CountUp value={98} suffix="%" duration={900} />
function CountUp({
  value,
  duration = 1100,
  decimals = 0,
  prefix = "",
  suffix = "",
  ...rest
}) {
  const target = Number(value) || 0;
  const [display, setDisplay] = useState(target);
  const fromRef = useRef(0);
  const startRef = useRef(null);

  useEffect(() => {
    const from = fromRef.current;
    let raf;
    startRef.current = null;

    const step = (ts) => {
      if (startRef.current === null) startRef.current = ts;
      const progress = Math.min((ts - startRef.current) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3); // easeOutCubic
      setDisplay(from + (target - from) * eased);
      if (progress < 1) {
        raf = requestAnimationFrame(step);
      } else {
        fromRef.current = target;
      }
    };

    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [target, duration]);

  const shown =
    decimals > 0 ? display.toFixed(decimals) : Math.round(display).toLocaleString();

  return (
    <span {...rest}>
      {prefix}
      {shown}
      {suffix}
    </span>
  );
}

export default CountUp;
